import {
  SEARCH_CONTRACTOR_FAIL,
  SEARCH_CONTRACTOR_REQUEST_SUCCESS
} from '../action.types'
import InitialState from '../initial.state'

export default (state = InitialState.contractor, action) => {
  switch (action.type) {
    case SEARCH_CONTRACTOR_REQUEST_SUCCESS:
      return [...action.payload]
    case SEARCH_CONTRACTOR_FAIL:
      return state
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/contractor/searchcontractor.reducer.js